import { render, staticRenderFns } from "./UnPay.vue?vue&type=template&id=dd2a8e12&scoped=true"
import script from "./UnPay.vue?vue&type=script&lang=js"
export * from "./UnPay.vue?vue&type=script&lang=js"
import style0 from "./UnPay.vue?vue&type=style&index=0&id=dd2a8e12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd2a8e12",
  null
  
)

export default component.exports